import PaintPurchaseReceiptsWorkspace from '../../placeholders/PaintPurchaseReceiptsWorkspace';

export default PaintPurchaseReceiptsWorkspace;
